import { useEffect, useState } from 'react';

import { Link } from '@bringg-frontend/ui';

import { meetupProvider } from '../data/meetup-provider';

export const TaskLink = ({ taskId }: { taskId: number }) => {
	const [taskTitle, setTaskTitle] = useState<string>('');

	useEffect(() => {
		let isMounted = true;

		if (!taskId) return;

		const loadTask = async () => {
			const { taskTitle } = await meetupProvider.loadData({ taskId });

			if (isMounted) {
				setTaskTitle(taskTitle);
			}
		};

		void loadTask();

		return () => {
			isMounted = false;
		};
	}, [taskId]);

	if (!taskId) return null;

	return (
		<Link to={`/history/${taskId}`} openInNewTab>
			{taskTitle}
		</Link>
	);
};
